// @flow
import translationsRu from './translations.ru'
import translateFunction from './translateFunc'

export const translations = translationsRu
export const translateFunc = translateFunction
